import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { LoaderModule, PipeModule } from '@app/shared';
import { FormsModule } from '@app/shared/forms';
import { NgbTooltipModule } from '@ng-bootstrap/ng-bootstrap';
import { TranslateModule } from '@ngx-translate/core';
import { InlineSVGModule } from 'ng-inline-svg-2';
import { LeaderboardTrialInvitesInfoModule } from '../leaderboard-trial-invites-info/leaderboard-trial-invites-info.module';

import { ReactiveFormsModule } from '@angular/forms';
import { IconComponent, LeaderboardDropdownComponent } from '@app/tw-shared/components';
import { LeaderboardGamificationHorizontalComponent } from './leaderboard-gamification-horizontal.component';

@NgModule({
    imports: [
        CommonModule,
        RouterModule,
        NgbTooltipModule,
        TranslateModule,
        LeaderboardTrialInvitesInfoModule,
        InlineSVGModule,
        LoaderModule,
        PipeModule,
        FormsModule,
        ReactiveFormsModule,
        IconComponent,
        LeaderboardDropdownComponent,
    ],
    declarations: [LeaderboardGamificationHorizontalComponent],
    exports: [LeaderboardGamificationHorizontalComponent],
})
export class LeaderboardGamificationHorizontalModule {}
